export enum XpoFacetFilterSortOptions {
  ASC = 'ASC',
  DESC = 'DESC',
}
